<template>
  <Container :keyword="filter" :action="() => _get()">
    <PageHeader
      :perPage="true"
      :title="$options.name"
      :filter="filter"
      :action="() => _get()"
    >
      <ButtonFilter :action="() => _trigger()" />
      <ButtonExcel :action="() => _createExcel()" />
    </PageHeader>
    <DataTable
      :skeleton="filter.requested"
      :noData="!filter.requested && response.data.length == 0"
      :show="!filter.requested && response.data.length > 0"
      :filter="filter"
      :pagination="true"
      :meta="response.meta"
      :format="'table-no-break'"
      :action="() => _get()"
    >
      <DataTableHeader :data="headers" :number="false" :action="true">
        <th>Due Date</th>
        <th>Limit Update</th>
      </DataTableHeader>
      <tbody>
        <tr v-for="(row, i) in response.data" :key="i">
          <template v-for="(header, j) in headers">
            <td :key="j" v-if="header in row" v-html="row[header]" />
          </template>
          <td>
            <input
              v-model="row.due_date_update"
              type="date"
              class="form-control"
              placeholder="due date limit"
            />
          </td>
          <td>
            <div style="width: 150px">
              <currency-input
                v-model="row.limit_update"
                class="form-control"
                placeholder="Inputkan limit"
              />
            </div>
          </td>
          <DataTableDropDownButton>
            <b-dropdown-item @click="_save(row)"> Update </b-dropdown-item>
            <b-dropdown-item @click="_reset(row)"> Reset </b-dropdown-item>
            <b-dropdown-item @click="_delete(row)"> Hapus </b-dropdown-item>
          </DataTableDropDownButton>
        </tr>
      </tbody>
    </DataTable>
    <FormFilter />
  </Container>
</template>

<script>
import helper from "@/assets/js/helper.js";
import FormFilter from "./modals/filter.vue";
import { mapState, mapActions } from "vuex";
export default {
  name: "LimitKredit",
  components: {
    FormFilter,
  },
  mixins: [helper],
  data() {
    return {
      headers: [
        "kode_toko",
        "nama_toko",
        "tim",
        "avg",
        "top",
        "limit",
        "rekomendasi",
      ],
    };
  },
  computed: {
    ...mapState(["loading", "is_mobile"]),
    ...mapState("limit_kredit", {
      filter: (state) => state.filter,
      response: (state) => state.response,
    }),
  },
  methods: {
    ...mapActions("limit_kredit", [
      "triggerModal",
      "getLimitKredit",
      "updateLimitKredit",
      "deleteLimitKredit",
    ]),
    _trigger() {
      return this.triggerModal("filter");
    },
    _get() {
      this.getLimitKredit().then((res) => {
        this._setHeaders(res);
      });
    },
    _setHeaders(res) {
      if (res.headers) {
        this.headers = res.headers;
      }
    },
    _save(res) {
      this.updateLimitKredit({
        id_toko: res.id_toko,
        limit: res.limit_update,
        due_date: res.due_date_update,
      });
    },
    _reset(res) {
      this.updateLimitKredit({
        id_toko: res.id_toko,
        limit: res.limit_rekomendasi_raw,
        due_date: res.due_date_update,
      });
    },
    _delete(res) {
      this.deleteLimitKredit(res.id_toko);
    },
    _createExcel() {
      let data_excel = [];
      this.response.data.forEach((data) => {
        data_excel.push(data.excel);
      });
      this.createExcel({
        data: data_excel,
        filename: "laporan-limit-kredit",
      });
    },
  },
  mounted() {
    this._get();
  },
  created() {},
};
</script>